export default {
    caption: {
        macrotrend: 'Macro-trend',
        reducedmacrotrend: 'Macro-trend',
        innovationfield: 'Innovation-field',
        innovationproject: 'Innovation-project'
    }
}
